/* eslint-disable camelcase */
import React, { useContext } from "react";
import Grid from "@material-ui/core/Grid";
import { useQuery } from "@apollo/client";
import { Typography } from "@material-ui/core";
import publicOrganization from "pages/eligibility/query/organization.gql";
import { FormData_layouts_groups, PublicOrganization, PublicOrganizationVariables } from "types/gql-types";
import OrganizationContext from "pages/eligibility/components/context/organization";
import Question, { QuestionProps } from "../question";
import { keyFromIdentity } from "../helpers";
import ProgressBar from "./progress-bar";
import MobileSectionsButton from "./mobile-sections-button";
import SectionHeader from "./section-header";

type SectionProps = {
  mobileMenu: { isMobile: boolean, toggle: () => void },
  groups: FormData_layouts_groups[],
  section: string,
  formTitle: string,
  questionsMap: {
    [x: string]: QuestionProps;
  },
  children?: (Element | React.ReactNode)[]
}

const Section: React.FC<SectionProps> =
({ mobileMenu, groups, section, questionsMap, children, formTitle }: SectionProps) => {
  const sectionData = groups
    .find(({ name }: { name: string }) => name === section) as FormData_layouts_groups;
  const sectionIndex = groups.findIndex(({ name }: { name: string }) => name === section);
  const percentComplete = `${((sectionIndex + 1) / groups.length) * 100}%`;

  const organizationData = useContext(OrganizationContext);

  const { loading, data } = organizationData.organizationId ? (
    useQuery<PublicOrganization, PublicOrganizationVariables>(publicOrganization, {
      variables: { id: organizationData.organizationId },
    })) : { loading: null, data: null };

  const { questions, title, description } = sectionData;
  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={12} container spacing={0} justifyContent="flex-start">
        <Grid item style={{ alignSelf: "center" }}>
          <Typography variant="h5">{formTitle}</Typography>
        </Grid>
        { sectionIndex === 0 && !loading && data?.publicOrganization.logoFilename &&
          <Grid item>
            <img
              src={data.publicOrganization.logoFilename}
              style={{
                paddingLeft: "1em",
                display: "block",
                margin: "auto",
                maxWidth: "430px",
                maxHeight: "110px",
              }}
            />
          </Grid>
        }
      </Grid>
      <ProgressBar percentComplete={percentComplete} />
      <MobileSectionsButton {...mobileMenu} />
      <SectionHeader title={title} description={description} />
      {questions.map((identity: string[]) => {
        const key = keyFromIdentity(identity);
        const params = questionsMap[key];
        return <Question key={key} {...params} questionsMap={questionsMap} variant="root" />;
      })}
      {children}
    </Grid>
  );
};

export default Section;
